<template>
  <div>
    <!-- ✅ Hero Slider -->
    <div v-if="banners.length > 0" id="heroCarousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          v-for="(banner, index) in banners"
          :key="banner._id"
          :class="['carousel-item', index === 0 ? 'active' : '']"
          :style="{ backgroundImage: 'url(' + banner.bannerImageUrl + ')' }"
          class="hero-slide"
        >
          <div class="hero-overlay">
            <div>
              <h1 v-if="banner.title">{{ banner.title }}</h1>
              <p v-if="banner.description">{{ banner.description }}</p>
              <a
                v-if="banner.redirectLink"
                :href="banner.redirectLink"
                class="btn btn-accent"
              >
                {{ banner.buttonText || 'Explore' }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>

    <!-- ✅ Categories Section -->
    <section v-if="categories.length > 0" class="categories py-5">
      <div class="container">
        <h2 class="section-title">Shop by Category</h2>
        <div class="row g-4">
          <div
            class="col-6 col-md-3"
            v-for="cat in categories"
            :key="cat._id"
          >
            <a :href="`/shop?category=${cat._id}`" class="category-card">
              <img
                :src="cat.categoryImageUrl"
                :alt="cat.title"
                class="img-fluid rounded"
              />
              <h5>{{ cat.title }}</h5>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- ✅ Products Section -->
    <section v-if="products.length > 0" class="py-5">
      <div class="container">
        <h2 class="section-title">Our Products</h2>
        <div class="row g-4">
          <div
            class="col-md-3 col-sm-6"
            v-for="product in products"
            :key="product._id"
          >
            <div class="card product-card position-relative">
              <!-- Offer Badge -->
              <span
                v-if="product.offerPrice"
                class="position-absolute top-0 start-0 bg-danger text-white px-2 py-1 rounded-end"
                style="font-size: 0.8rem;"
              >
                {{ product.offerPriceText || 'On Sale' }}
              </span>

              <!-- Product Image -->
              <a href="javascript:void(0)" @click="$router.push(`/product/${product.slug}`)" >
              <img
                :src="product.mainImageUrl"
                class="card-img-top"
                :alt="product.name"
              />
              </a>

              <!-- Product Details -->
              <div class="card-body text-center">
                <h6 class="card-title">{{ product.name }}</h6>

                <!-- Price Display -->
                <p class="mb-1">
                  <span
                    v-if="product.offerPrice"
                    class="text-muted text-decoration-line-through me-2"
                  >
                    ₹{{ product.price }}
                  </span>
                  <span :class="product.offerPrice ? 'fw-bold text-danger' : 'fw-bold'">
                    ₹{{ product.offerPrice || product.price }}
                  </span>
                </p>

                <a href="javascript:void(0)" @click="addProductToCart(product, true)" class="btn btn-accent btn-sm">Buy Now</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- Flash Sale -->
    <!--<section class="py-5">
      <div class="container">
        <div class="flash-sale">
          <h2>🔥 Flash Sale</h2>
          <p>Get 30% off on selected items for a limited time only!</p>
          <a href="#" class="btn btn-accent">Shop Sale</a>
        </div>
      </div>
    </section>-->

    <!-- Workshops -->
    <section class="workshops-modern py-5">
      <div class="container">
        <h2 class="section-title">🎨 Upcoming Workshops</h2>
        <div class="row g-4">
          <div class="col-md-6" v-for="workshop in workshops"
            :key="workshop._id">
            <div class="workshop-card">
              <h5>{{ workshop.title }}</h5>
              <p><i class="fa fa-calendar"></i> {{ workshop.date }} | {{ workshop.time }}</p>
              <p><i class="fa fa-map-marker"></i> {{ workshop.address }}</p>
              <p>₹{{ workshop.price }}</p>
              <a href="#" class="btn btn-accent btn-sm">Register</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Blog -->
    <section class="py-5">
      <div class="container">
        <h2 class="section-title">From Our Blog</h2>
        <div class="row g-4">
          <div class="col-md-4" v-for="i in 3" :key="i">
            <div class="card">
              <img src="images/blogs/blog1.jpg" class="card-img-top" alt="Blog" />
              <div class="card-body">
                <h5>How Handmade Gifts Create Memories</h5>
                <a href="#" class="btn btn-sm btn-accent">Read More</a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-4">
          <a href="#" class="btn btn-accent">View All Blogs</a>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// @ is an alias to /src
import {useToast} from 'vue-toast-notification';
const $toast = useToast();

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import BannerService from "../services/BannerService";
import ProductService from "../services/ProductService";
import { EventBus } from '@/eventBus'

export default {
  name: 'HomeView',
  components: {
    VueTelInput
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
      banners: [],
      categories: [],
      products: [],
      workshops: [],
    };
  },
  methods: {
    getBanners() {
      BannerService.getBanners()
        .then((response) => {
            this.banners = response.data.data;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    getHomePageData() {
      ProductService.getHomePageData()
        .then((response) => {
            this.categories = response.data.data.categories;
            this.products = response.data.data.products;
            this.workshops = response.data.data.workshops;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async addProductToCart(product, redirectToCartPage = false) {
      let data = {
        productId: product._id,
        productDetail: product,
        qty: 1,
      };

      await ProductService.addProductToCart(data)
        .then((response) => {
          EventBus.emit('cart-updated')
          $toast.success(response.data.respones_msg);
          if (redirectToCartPage) {
            this.$router.push({ path: '/cart' });
          }
        })
        .catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.getBanners()
    this.getHomePageData()
  },
  created () {
  },
}
</script>
<style scoped>

</style>